module.exports = __webpack_public_path__ + "img/6_164.83fa8634.png";